export default {
  path: "/wecode/executActionLog",
  auth: true,
  preload: false,
  key: "ExecutActionLog",
  layout: "inner", // outer 一级菜单 inner 二级菜单
  component: props => import("./index")
};
